import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpProjectCreatedPage } from '@/features/pcmp/pages/PcmpProjectCreatedPage';

export const Route = createFileRoute('/_auth/pcmp/projects/$projectId/created')({
  parseParams: ({ projectId }) => {
    const parsedId = Number(projectId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { projectId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="PCMP Project Created">
      <Suspense fallback={<PageLoader />}>
        <PcmpProjectCreatedPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
